export function getPrescriptionTypeArrowTargetIndex(
  key: string,
  currentIndex: number,
  itemCount: number,
) {
  if (itemCount < 2) return null;

  const direction =
    key === 'ArrowRight' || key === 'ArrowDown'
      ? 1
      : key === 'ArrowLeft' || key === 'ArrowUp'
        ? -1
        : 0;

  if (!direction) return null;

  return (currentIndex + direction + itemCount) % itemCount;
}
